import { Center, Spinner, Text } from '@chakra-ui/react';

interface SplashScreenProps {}

const SplashScreen: React.FC<SplashScreenProps> = () => {
  return (
    <Center w="100%" h="100%">
      <Center flexDirection="column">
        <Text fontSize={20} mb="42px">
          Kolumboos PMS
        </Text>
        <Spinner size="xl" thickness="3px" speed="0.65s" emptyColor="gray.200" />
      </Center>
    </Center>
  );
};

export default SplashScreen;
